import React, { useState, useEffect, useMemo } from "react";
import "../Assests/Scss/AddUpdateQuestions.scss";
import Loading from "../../../Student/Reusablecomponents/Loading";

import ScenarioQuestionformat from "../../../Student/Reusablecomponents/ScenarioQuestionformat";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import {
  MainSource,
  SubMainSource,
  QVStatus,
  QuestionLevel,
  FormQuestions,
  BloomTaxonomy,
} from "../../../ReusableComponents/QBDropdowns";
import {
  Situation,
  TextFormat,
  TType,
  GradeDD,
  ChapterDD,
  Booktype,
  PLOneDD,
  PLTwoDD,
  PLThreeDD,
  GrammerDD,
  UnitNumber,
  UnitName,
} from "../../../ReusableComponents/QBEnglishDropdowns";
import { HBookDD, HBookTypeSubDropDowns } from "../../../ReusableComponents/QBAdmin/Hindi/QBHindiDropdowns";
import HBookSubDropDowns from "../../../ReusableComponents/QBAdmin/Hindi/QBHindiDropdowns";

import { TBookDD, TBookTypeSubDropDowns } from "../../../ReusableComponents/QBAdmin/Telugu/QBTeluguDropdowns";
import TBookSubDropDowns from "../../../ReusableComponents/QBAdmin/Telugu/QBTeluguDropdowns";


import { GoTriangleDown } from "react-icons/go";
import { Row, Col } from "react-bootstrap";
import TinyMCEDitor from "../../../ReusableComponents/tinymceEditor";
import notify from "../../../ReusableComponents/ToastifyAlerts";
import { useNavigate, useLocation } from "react-router-dom";
import * as Yup from "yup";
import QS from "../Assests/images/QuestionSource.svg";
import Q from "../Assests/images/Question.svg";
// import LO from "../Assests/images/LO.svg";
import AP from "../Assests/images/AParameters.svg";
import Forms from "../Assests/images/Forms.svg";
import axiosInstance from "../../../ReusableComponents/Axios";
import QBCList from "../../../ReusableComponents/QBCheckList";
import {
  StageDD, CircularGoalDD, CompetenciesDD,
} from "../../../ReusableComponents/QBAdmin/CommonDropdowns";
import { IoInformationCircleOutline } from "react-icons/io5";
import { IoMdCloseCircleOutline } from "react-icons/io";
import DataTable from "../../../Student/Reusablecomponents/DataTable/DataTable";
const AddUpdatHindiQuestions = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const BTCore = "Core";
  const BTElective = "Elective";
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );
  const updateScenario = useSelector(
    (state) => state.ScenarioDeatils.ScenarioDetails
  );
  const GetQuestion = useSelector(
    (state) => state.QuestionDeatils.QuestionDetails
  );
  const Scenario = useSelector(
    (state) => state.ScenarioDeatils.ScenarioDetails
  );
  // const FQuestionDetails = useSelector((state) => state.FQDetails.FQDetails);
  const [Load, SetLoad] = useState(false);
  const [MDQ, SetMDQ] = useState(
    GetQuestion
      ? GetQuestion?.questionType
      : location.state?.Tab === "INQ"
        ? "D"
        : "M"
  );

  const [Accordion, SetAccordion] = useState("All");

  const [EditorValues, SetEditorValues] = useState({
    Question: GetQuestion?.question || "",
    Answer: GetQuestion?.answer || "",
    OptionA: GetQuestion?.optionA || "",
    OptionB: GetQuestion?.optionB || "",
    OptionC: GetQuestion?.optionC || "",
    OptionD: GetQuestion?.optionD || "",
    Explanation: GetQuestion?.answerExplanation || "",
    Misconception: GetQuestion?.misconception || "",
  });
  const [OComments, SetOComments] = useState({
    Source: GetQuestion?.otherQSource || "",
    Verification: GetQuestion?.verificationComment || "",
    Form: GetQuestion?.otherFormComments || "",
  });

  const [NTBased, SetNTBased] = useState(GetQuestion?.sSourceLovId || "");
  const [SNTBased, SetSNTBased] = useState(GetQuestion?.sSourceValueId || "");
  const [VStatus, SetVStatus] = useState(GetQuestion?.qStatus || "");

  const [Grammer, SetGrammer] = useState(GetQuestion?.grammerId || "");
  const [QLevel, SetQLevel] = useState(GetQuestion?.level || "");
  const [BTaxonomy, SetBTaxonomy] = useState(GetQuestion?.bloomsTaxonomy || "");

  const [FormQ, SetFormQ] = useState(GetQuestion?.elementType || []);

  const [AQErrors, SetAQErrors] = useState({});

  const [DisplayDD, SetDisplayDD] = useState(
    updateScenario?.engType || GetQuestion?.engType || "RC"
  );
  const [Grade, SetGrade] = useState({
    display: updateScenario?.gradeName || GetQuestion?.gradeName,
    value: updateScenario?.englishGrade || GetQuestion?.englishGrade,
  });
  const [UNitNumber, SetUNitNumber] = useState(
    updateScenario?.unitNumber || GetQuestion?.unitNumber || ""
  );
  const [UNitName, SetUNitName] = useState(
    updateScenario?.unitName || GetQuestion?.unitName || ""
  );

  const [Chapter, SetChapter] = useState(
    updateScenario?.unit || GetQuestion?.unit
  );
  const [Book, SetBook] = useState(updateScenario?.book || GetQuestion?.book);
  const [BType, SetBType] = useState({
    display: updateScenario?.gcTypeName || GetQuestion?.gcTypeName,
    value: updateScenario?.gcTypeId || GetQuestion?.gcTypeId,
  });
  const [BSUB, SetBSUB] = useState({
    MR: updateScenario?.mainReading || GetQuestion?.mainReading || "",
    Poem: updateScenario?.mainReadingPoem || GetQuestion?.mainReadingPoem || "",
    NDL:
      updateScenario?.nonDetailedLesson || GetQuestion?.nonDetailedLesson || "",
  });
  const [BTSUB, SetBTSUB] = useState({
    SS: updateScenario?.shortstoriesId || GetQuestion?.shortstoriesId || "",
    Poem: updateScenario?.mainReadingPoem || GetQuestion?.mainReadingPoem || "",
    NFI:
      updateScenario?.nonFictionIntroductionId ||
      GetQuestion?.nonFictionIntroductionId ||
      "",
    DI:
      updateScenario?.dramaIntroductionId ||
      GetQuestion?.dramaIntroductionId ||
      "",
    Essay: updateScenario?.essayId || GetQuestion?.essayId || "",
  });
  const [SStage, SetSStage] = useState(GetQuestion?.stage || "");
  const [SCGoal, SetSCGoal] = useState(GetQuestion?.curricularGoal || "");
  const [Competencie, SetCompetencie] = useState(GetQuestion?.competency || "");
  const [OpenDeatils, SetOpenDeatils] = useState(false);
  const [FSCGoal, SetFSCGoal] = useState();
  const [FCompetencie, SetFCompetencie] = useState();
  const [SLevelOne, SetSLevelOne] = useState(
    updateScenario?.situation || GetQuestion?.situation || ""
  );
  const [TFormat, SetTFormat] = useState(
    updateScenario?.text_Format || GetQuestion?.text_Format || ""
  );
  const [TexType, SetTexType] = useState(
    updateScenario?.text_Type || GetQuestion?.text_Type || ""
  );
  const [LevelOne, SetLevelOne] = useState(GetQuestion?.processLevel1 || "");
  const [LevelTwo, SetLevelTwo] = useState(GetQuestion?.processLevel2 || "");
  const [LevelThree, SetLevelThree] = useState(
    GetQuestion?.processLevel3 || ""
  );
  const validationSchema = Yup.object().shape({
    NTBased: Yup.string().required("Source is required"),
    SNTBased: Yup.string().required("Source is required"),
    VStatus: Yup.string().required("Question Verification status is required"),
    Question: Yup.string().required("Question is required"),
    Answer: Yup.string().required("Answer is required"),
    OptionA: Yup.string().when("MDQ", {
      is: () => MDQ === "M",
      then: (schema) => Yup.string().required("Option A is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),

    OptionB: Yup.string().when("MDQ", {
      is: () => MDQ === "M",
      then: () => Yup.string().required("Option B is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    QForm: Yup.string().required("Forms in Question is required"),
    Form: Yup.string().when("FormQ", {
      is: (FormQ) => FormQ.includes(4002),
      then: (schema) => Yup.string().required("Form input Field is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    Source: Yup.string().when("SNTBased", {
      is: (SNTBased) => SNTBased === 3574 || SNTBased === 3578,
      then: (schema) => Yup.string().required("Source input Field is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    // Grade: Yup.string().required("Grade  is required"),
    Grade: Yup.object({
      // data: Yup.object({
      value: Yup.string()
        .required("Grade is required")
        .matches(/^-?\d+$/, "Grade must be a number") // only digits allowed (handles negatives too)
        .test("is-greater", "Grade is required", function (value) {
          if (!value) return false; // catches empty
          return parseInt(value, 10) > 0;
        }),
      //  .matches(/^\d+$/, "Grade must be a number"),
      // .min(1, "Grade must be greater than 0")
      // .typeError("Value must be a number"),
      // }),
    }),
    UNitNumber: Yup.string().when("DisplayDD", {
      is: () =>
        DisplayDD === "RC" &&
        (
          // Grade?.display === "1" ||
          // Grade?.display === "2" ||
          Grade?.display === "Pre-primary"),
      then: (schema) => Yup.string().required("Unit Number is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    UNitName: Yup.string().when("DisplayDD", {
      is: () =>
        DisplayDD === "RC" &&
        (
          // Grade?.display === "1" ||
          // Grade?.display === "2" ||
          Grade?.display === "Pre-primary"),
      then: (schema) => Yup.string().required("UNit Name is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    Chapter: Yup.string().when("DisplayDD", {
      is: () => DisplayDD === "RC",
      then: (schema) => Yup.string().required("Chapter is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    Book: Yup.string().when("DisplayDD", {
      is: () => DisplayDD === "RC",
      then: (schema) => Yup.string().required("Book is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    QLevel: Yup.string().required("Question Level  is required"),
    BTaxonomy: Yup.string().required("Bloom's Taxonomy  is required"),

    SLevelOne: Yup.string().when("DisplayDD", {
      is: () => DisplayDD === "RC",
      then: (schema) => Yup.string().required("Situation is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    TFormat: Yup.string().when("DisplayDD", {
      is: () => DisplayDD === "RC",
      then: (schema) => Yup.string().required("Text Format is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    TexType: Yup.string().when("DisplayDD", {
      is: () => DisplayDD === "RC",
      then: (schema) => Yup.string().required("Text Type is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),

    SStage: Yup.string().required("Stage is required"),
    SCGoal: Yup.string().required("Curricular Goal is required"),
    Competencie: Yup.string().required("Competencies is required"),
    LevelOne: Yup.string().when("DisplayDD", {
      is: () => DisplayDD === "RC",
      then: (schema) => Yup.string().required("Level 1 is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    LevelTwo: Yup.string().when("DisplayDD", {
      is: () => DisplayDD === "RC",
      then: (schema) => Yup.string().required("Level 2 is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    LevelThree: Yup.string().when("DisplayDD", {
      is: () => DisplayDD === "RC",
      then: (schema) => Yup.string().required("Level 3 is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),

    Grammer: Yup.string().when("DisplayDD", {
      is: () => DisplayDD === "G",
      then: (schema) => Yup.string().required("Grammer is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
  });

  const OpenAccordain = (e) => {
    if (Accordion === e) {
      SetAccordion();
    } else {
      SetAccordion(e);
    }
  };
  const StoreEditorValues = (Name, Values) => {
    SetEditorValues({ ...EditorValues, [Name]: Values });
  };
  const HandelOComments = (Name, Values) => {
    SetOComments({ ...OComments, [Name]: Values });
  };
  const FormSOptions = (e) => {
    if (FormQ.includes(e)) {
      SetFormQ((prevItems) => prevItems.filter((item) => item !== e));
    } else {
      SetFormQ([...FormQ, e]);
    }
  };
  const QForm = FormQ?.join(",");

  const AddQuestion = async () => {
    SetLoad((prev) => !prev);
    const QuestionInputs = {
      questionID: 0,
      scenarioID: Scenario?.scenarioID || 0,
      // || location.state?.SID
      questionType: MDQ,
      subjectId: items?.subjectId,
      sSourceLovId: NTBased,
      sSourceId: SNTBased,
      otherQSource: OComments?.Source,
      qStatus: VStatus,
      verificationComment: OComments?.Verification,

      question: EditorValues?.Question.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      answer: EditorValues?.Answer.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionA: EditorValues?.OptionA.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionB: EditorValues?.OptionB.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionC: EditorValues?.OptionC.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionD: EditorValues?.OptionD.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionE: "",
      answerExplanation: EditorValues?.Explanation,
      misconception: EditorValues?.Misconception,

      createdBy: items?.userId,
      modifiedBy: 0,
      processLevel1: LevelOne || 0,
      processLevel2: LevelTwo || 0,
      processLevel3: LevelThree || 0,
      stage: SStage || 0,
      curricularGoal: SCGoal || 0,
      competency: Competencie || 0,
      situation: SLevelOne || 0,
      text_Format: TFormat || 0,
      text_Type: TexType || 0,
      medium: 0,
      enviornment: 0,
      EngType: DisplayDD,
      englishGrade: Grade?.value,
      unit: Chapter || 0,
      book: Book || 0,
      gcTypeId: BType?.value,
      grammerId: Grammer || 0,
      mainReading: BSUB.MR || 0,
      nonDetailedLesson: BSUB.NDL || 0,
      mainReadingPoem: BSUB.Poem || BTSUB.Poem || 0,

      shortstoriesId: BTSUB.SS || 0,
      essayId: BTSUB.Essay || 0,
      nonFictionIntroductionId: BTSUB.NFI || 0,
      dramaIntroductionId: BTSUB.DI || 0,

      level: QLevel || 0,
      bloomsTaxonomy: BTaxonomy || 0,

      elementType: QForm,
      otherFormComments: OComments?.Form,
      UnitNumber: UNitNumber || 0,
      UnitName: UNitName || 0,
      addScenarioQuestionChecklist: QCValues,
      // AnswerType: AType || 0,
      // AnswerValType: AVType || 0,
      // AnswerValue: RangeInputs?.join(","),
      // UnitId: Units || 0,
    };
    await axios
      .post(
        process.env.REACT_APP_API_BASE_URL +
        `/EnglishQuestionBank/AddLanguageQuestion`,
        QuestionInputs,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        switch (res.data) {
          case 1: notify("Question added successfully", "success");
            navigate(-1);
            break;
          case 999: notify("Question Already Exists", "warning");
            break;
          default: notify("Question not added. Please try again", "error");
            break;
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
        notify("Question not added. Please try again", "error");
        SetLoad((prev) => !prev);
      });
  };
  const UpadetQuestion = async () => {
    SetLoad((prev) => !prev);
    const QuestionInputs = {
      questionID: GetQuestion?.questionID,
      scenarioID: Scenario?.scenarioID || GetQuestion?.scenarioID || 0,
      questionType: MDQ,
      subjectId: items?.subjectId,
      sSourceLovId: NTBased,
      sSourceId: SNTBased,
      otherQSource: OComments?.Source,
      verificationComment: OComments?.Verification,
      qStatus: VStatus,
      question: EditorValues?.Question.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      answer: EditorValues?.Answer.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionA: EditorValues?.OptionA.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionB: EditorValues?.OptionB.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionC: EditorValues?.OptionC.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionD: EditorValues?.OptionD.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      optionE: "",
      answerExplanation: EditorValues?.Explanation,
      misconception: EditorValues?.Misconception,
      createdBy: 0,
      modifiedBy: items?.userId,
      stage: SStage || 0,
      curricularGoal: SCGoal || 0,
      competency: Competencie || 0,
      processLevel1: LevelOne || 0,
      processLevel2: LevelTwo || 0,
      processLevel3: LevelThree || 0,
      situation: SLevelOne || 0,
      text_Format: TFormat || 0,
      text_Type: TexType || 0,
      medium: 0,
      enviornment: 0,
      EngType: DisplayDD,
      englishGrade: Grade?.value,
      unit: Chapter || 0,
      book: Book || 0,
      gcTypeId: BType?.value,
      grammerId: Grammer || 0,
      mainReading: BSUB.MR || 0,
      nonDetailedLesson: BSUB.NDL || 0,
      mainReadingPoem: BSUB.Poem || BTSUB.Poem || 0,
      shortstoriesId: BTSUB.SS || 0,
      essayId: BTSUB.Essay || 0,
      nonFictionIntroductionId: BTSUB.NFI || 0,
      dramaIntroductionId: BTSUB.DI || 0,
      level: QLevel || 0,
      bloomsTaxonomy: BTaxonomy || 0,
      elementType: QForm,
      otherFormComments: OComments?.Form,
      UnitNumber: UNitNumber || 0,
      UnitName: UNitName || 0,
      // AnswerType: AType || 0,
      // AnswerValType: AVType || 0,
      // AnswerValue: RangeInputs?.join(","),
      // UnitId: Units || 0,
      addScenarioQuestionChecklist: QCValues,
    };
    await axios
      .post(
        process.env.REACT_APP_API_BASE_URL +
        `/EnglishQuestionBank/UpdatLanguageQuestion`,
        QuestionInputs,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        notify("Question updated successfully", "success");
        SetLoad((prev) => !prev);
        navigate(-1);
      })
      .catch((err) => {
        notify("Question not updated. Please try again", "error");
        SetLoad((prev) => !prev);
      });
  };
  const YupValidation = () => {
    const AllFields = {
      ...EditorValues,
      NTBased,
      SNTBased,
      QForm,
      VStatus,
      DisplayDD,
      ...OComments,
      QLevel,
      BTaxonomy,
      FormQ,
      SLevelOne,
      TFormat,
      TexType,
      SStage, SCGoal, Competencie,
      LevelOne,
      LevelTwo,
      LevelThree,
      Grade,
      Chapter,
      Book,
      BType,
      Grammer,
      UNitNumber,
      UNitName,
    };
    validationSchema
      .validate(AllFields, { abortEarly: false })
      .then(() => {
        if (CValidation) {
          Validation();
        }
        SetAQErrors({});
      })
      .catch((err) => {
        const newErrors = {};
        if (Array.isArray(err.inner)) {
          err.inner.forEach((error) => {
            newErrors[error.path] = error.message;
          });
        }
        SetAQErrors(newErrors);
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
  };

  const BackPreviousPage = () => {
    navigate(-1);
  };
  const Validation = () => {
    if (DisplayDD !== "G") {
      if (BType?.display !== BTElective) {
        if (BSUB.MR || BSUB.Poem || BSUB.NDL) {
          if (GetQuestion) {
            UpadetQuestion();
          } else {
            AddQuestion();
          }
        } else {
          notify(
            "Please select any one of the fields - Main Reading, Poem, or Non-Detailed Lesson",
            "warning"
          );
        }
      } else if (
        BTSUB.SS ||
        BTSUB.Poem ||
        BTSUB.NFI ||
        BTSUB.DI ||
        BTSUB.Essay
      ) {
        if (GetQuestion) {
          UpadetQuestion();
        } else {
          AddQuestion();
        }
      } else {
        notify(
          `Please select any one of the fields - Short Stories,Poem,  ${Grade?.value === 51 ? "Essay" : "Non-Fiction,Drama"
          }`,
          "warning"
        );
      }
    } else {
      if (GetQuestion) {
        UpadetQuestion();
      } else {
        AddQuestion();
      }
    }
  };
  const HandleDisplay = (e) => {
    SetDisplayDD(e);
    SetSLevelOne("");
    SetTFormat("");
    SetTexType("");
    SetChapter("");
    SetBook("");
    SetBSUB("");
    SetBTSUB("");
    SetLevelOne("");
    SetLevelTwo("");
    SetLevelThree("");
    
     SetGrammer("");
    ClearSUbDD();
    SetSLevelOne("");
  SetTFormat("");
  SetTexType("");
  };
  const ClearSUbDD = (e) => {
    // SetGrade(e);
    SetUNitNumber("");
    SetUNitName("");
    SetBSUB({ MR: "", Poem: "", NDL: "" });
    SetBTSUB({ SS: "", Poem: "", NFI: "", DI: "", Essay: "" });
  };

  useMemo(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  const [HitCLV, SetHitCLV] = useState(false);
  const [CValidation, SetCValidation] = useState(false);
  const [QCValues, SetQCValues] = useState();
  useEffect(() => {
    if (CValidation && Object.keys(AQErrors).length === 0) {
      Validation();
    }
  }, [CValidation]);
  const Columns = [
    { name: "Code", selector: "lovName", sortable: true },
    {
      name: "Description", selector: "lovDescription", sortable: true,
      cell: (row) => (<div style={{ textAlign: "justify" }}>{row.lovDescription} </div>),
    },
  ];
  return (
    <>
      <div className="MainHeading">
        {GetQuestion ? "Update" : "Add"} Question
      </div>
      {Scenario?.scenarioID > 0 && (
        <div className="Card mb-3">
          <div className="SubHeading mb-2">
            Scenario (Id - {Scenario?.scenarioID || location.state?.SID})
          </div>
          <ScenarioQuestionformat scenario={Scenario?.scenarioName} />
        </div>
      )}
      <div className="Card">
        {GetQuestion && (
          <div className="SubHeading mb-2">
            Question (Id - {GetQuestion?.questionID})
          </div>
        )}
        <div className="dflex alignitems mb-2" style={{ gap: "30px" }}>
          {["M", "D"].map((item) => (
            <div className="dflex alignitems" style={{ gap: "5px" }}>
              <input
                type="radio"
                value={item}
                checked={item === MDQ}
                name="Qtype"
                disabled={location.state?.Tab === "INQ" || GetQuestion}
                onChange={(e) => {
                  if (!GetQuestion) {
                    SetEditorValues({ ...EditorValues, Answer: "" });
                  }
                  SetMDQ(e.target.value);
                }}
              />{" "}
              {item === "M" ? "MCQ" : "NON MCQ"}
            </div>
          ))}
        </div>
        <div>
          <div className="AddOptions">
            <div className="dflex alignitems JSBetween AUTitles">
              <div className="dflex alignitems">
                {" "}
                <img src={QS} alt="Question Source" />{" "}
                <div>
                  Question Source<span className="text-danger">*</span>
                </div>
              </div>{" "}
              <GoTriangleDown onClick={() => OpenAccordain("QS")} />
            </div>
            {Accordion !== "QS" && (
              <div className="container-fluid mt-2">
                <Row>
                  <Col>
                    <MainSource
                      className="NCLDropdown w-100 mb-2"
                      StoreMSource={SetNTBased}
                      SOption={NTBased}
                      onChange={(e) => SetNTBased(e)}
                      labelname={
                        <div className="DropdownHeader">
                          Source<span>*</span>
                        </div>
                      }
                      LID={SelectLanguage}
                    />
                    {AQErrors?.NTBased && (
                      <span className="error-message">{AQErrors?.NTBased}</span>
                    )}

                    <SubMainSource
                      className="NCLDropdown w-100"
                      StoreSMSource={SetSNTBased}
                      SOption={SNTBased}
                      PId={NTBased}
                      onChange={(e) => SetSNTBased(e)}
                      LID={SelectLanguage}
                    />
                    {AQErrors?.SNTBased && (
                      <span className="error-message">
                        {AQErrors?.SNTBased}
                      </span>
                    )}

                    {(SNTBased === 3574 || SNTBased === 3578) && (
                      <input
                        type="text"
                        className="Search mt-2 p-1 w-100"
                        onChange={(e) =>
                          HandelOComments("Source", e.target.value)
                        }
                        placeholder="Enter Comments"
                      />
                    )}
                    {AQErrors?.Source && (
                      <span className="error-message">{AQErrors?.Source}</span>
                    )}
                  </Col>
                  <Col>
                    <QVStatus
                      className="NCLDropdown w-100 mb-2"
                      StoreValue={SetVStatus}
                      SOption={VStatus}
                      onChange={(e) => SetVStatus(e)}
                      LID={SelectLanguage}
                    />
                    {AQErrors?.VStatus && (
                      <span
                        className="error-message"
                        style={{ marginLeft: "10px" }}
                      >
                        {AQErrors?.VStatus}{" "}
                      </span>
                    )}
                    <input
                      type="text"
                      placeholder="Enter text"
                      value={OComments?.Verification}
                      className="Search p-1 w-100"
                      onChange={(e) =>
                        HandelOComments("Verification", e.target.value)
                      }
                    />
                  </Col>
                </Row>
              </div>
            )}
          </div>

          <div className="AddOptions">
            <div className="dflex alignitems JSBetween AUTitles">
              <div className="dflex alignitems">
                {" "}
                <img src={Q} alt="Question" />{" "}
                <div>
                  Question<span className="text-danger">*</span>
                </div>
              </div>{" "}
              <GoTriangleDown onClick={() => OpenAccordain("Q")} />
            </div>
            {Accordion !== "Q" && (
              <div className="container-fluid mt-2QuestionOptions">
                <Row>
                  <Col>
                    {" "}
                    <div className="DropdownHeader">
                      Question<span>*</span>
                    </div>
                    <TinyMCEDitor LngValue={items?.subjectId == "4" ? "hi" : "te"}
                      onChange={(e) => StoreEditorValues("Question", e)}
                      Review={true} PostValue={
                        EditorValues?.Question
                      }
                    />
                    {AQErrors?.Question && (
                      <span className="error-message">
                        {AQErrors?.Question}
                      </span>
                    )}
                  </Col>
                  <Col>
                    {" "}
                    <div className="DropdownHeader">
                      Answer<span>*</span>
                    </div>
                    {MDQ === "M" ? (
                      <div
                        className="dflex InputFIlters mt-3 "
                        style={{ gap: "15px" }}
                      >
                        <label style={{ backgroundColor: "white" }}>
                          Select Answer
                        </label>
                        {["A", "B", "C", "D"].map((option, i) => (
                          <div
                            key={i}
                            className="dflex alignitems"
                            onChange={() => StoreEditorValues("Answer", option)}
                            style={{ gap: "5px", fontSize: "15px" }}
                          >
                            <input disabled={GetQuestion?.qUsed}
                              type="radio"
                              value={option}
                              name="Answer"
                              checked={option == EditorValues?.Answer}
                            />{" "}
                            {option}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className={`${GetQuestion?.qUsed && "DisabledTiny"}`}>
                        <TinyMCEDitor disable={GetQuestion?.qUsed} Review={true} LngValue={items?.subjectId == "4" ? "hi" : "te"}
                          onChange={(e) => StoreEditorValues("Answer", e)}
                          PostValue={EditorValues?.Answer}
                        /></div>
                    )}
                    {AQErrors?.Answer && (
                      <span className="error-message">{AQErrors?.Answer}</span>
                    )}
                  </Col>
                </Row>

                {MDQ !== "D" && (
                  <>
                    <Row>
                      {["A", "B"].map((item, index) => (
                        <Col key={index}>
                          {" "}
                          <div className="DropdownHeader">
                            Option {item}
                            <span>*</span>
                          </div>
                          <TinyMCEDitor Review={true} LngValue={items?.subjectId == "4" ? "hi" : "te"}
                            onChange={(e) =>
                              StoreEditorValues(`Option${item}`, e)
                            }
                            PostValue={EditorValues?.[`Option${item}`]}
                          />
                          {AQErrors?.[`Option${item}`] && (
                            <span className="error-message">
                              {AQErrors?.[`Option${item}`]}
                            </span>
                          )}
                        </Col>
                      ))}
                    </Row>

                    <Row>
                      {" "}
                      {["C", "D"].map((item, index) => (
                        <Col key={index}>
                          {" "}
                          <div className="DropdownHeader">Option {item} </div>
                          <TinyMCEDitor Review={true} LngValue={items?.subjectId == "4" ? "hi" : "te"}
                            onChange={(e) =>
                              StoreEditorValues(`Option${item}`, e)
                            }
                            PostValue={EditorValues?.[`Option${item}`]}
                          />
                        </Col>
                      ))}
                    </Row>
                  </>
                )}
                <Row>
                  {" "}
                  {["Explanation", "Misconception"].map((item, index) => (
                    <Col key={index}>
                      {" "}
                      <div className="DropdownHeader">{item} </div>
                      <TinyMCEDitor Review={true} LngValue={items?.subjectId == "4" ? "hi" : "te"}
                        onChange={(e) => StoreEditorValues(item, e)}
                        PostValue={EditorValues?.[item]}
                      />
                    </Col>
                  ))}
                </Row>
              </div>
            )}
          </div>

          <div className="dflex  mt-3" style={{ gap: "15px" }}>
            {["RC", "G"].map((Item) => (
              <div
                key={Item}
                className="dflex alignitems"
                style={{ gap: "5px" }}
              >
                <input
                  type="Radio"
                  value={Item}
                  name="NSBased"
                  disabled={updateScenario || localStorage.getItem("ERCG") === "true"}
                  checked={DisplayDD === Item}
                  onChange={() => HandleDisplay(Item)}
                />{" "}
                <b>{Item === "G" ? "Grammar" : "Reading Comprehension"}</b>
              </div>
            ))}
          </div>

          <div className="AddOptions">
            <div className="dflex alignitems AUTitles">
              <div className="dflex alignitems">
                {" "}
                <img src={AP} alt="Learning Outcomes" />{" "}
                <div>
                  Grade and Curriculum Mapping
                  <span className="text-danger">*</span>{" "}
                </div>
              </div>{" "}
            </div>
            <div className="container-fluid">
              <Row>
                <Col>
                  <GradeDD
                    Change={true}
                    className={`w-100 ${updateScenario ? "DisabledNCLDropdown" : "NCLDropdown"
                      }`}
                    StoreMSource={SetGrade}
                    SOption={Grade?.value}
                    onChange={(e) => {
                      ClearSUbDD(e ? parseInt(e) : e);
                    }}
                    Displayname="Select Grade"
                    disable={updateScenario}
                    labelname={
                      <div className="DropdownHeader">
                        Grade<span>*</span>
                      </div>
                    }
                  />
                  {AQErrors?.["Grade.value"] && (
                    <span className="error-message">
                      {AQErrors?.["Grade.value"]}
                    </span>
                  )}
                </Col>
                <Col >
                  <div style={DisplayDD === "G" ? { display: "none" } : {}}>
                    <Booktype
                      className={`w-100 ${(Grade?.value !== 52 && Grade?.value !== 51) ||
                        updateScenario
                        ? "DisabledNCLDropdown"
                        : "NCLDropdown"
                        }`}
                      StoreMSource={SetBType}
                      SOption={BType}
                      Grade={Grade?.value}
                      onChange={(e) => SetBType(e)}
                      disable={
                        (Grade?.value !== 52 && Grade?.value !== 51) ||
                        updateScenario
                      }
                      labelname={
                        <div className="DropdownHeader">
                          Book Type<span>*</span>
                        </div>
                      }
                    /></div>
                </Col>
              </Row>

              {( Grade?.display === "Pre-primary") &&
                DisplayDD !== "G" && (
                  <Row>
                    <Col>
                      <UnitNumber SID={items?.subjectId} LoID={items?.subjectId == "4" ? 127 : 124}
                        className={`w-100 ${updateScenario ? "DisabledNCLDropdown" : "NCLDropdown"
                          }`}
                        Displayname="Select Unit Number"
                        PID={Grade?.value}
                        LID={SelectLanguage}
                        disable={updateScenario}
                        StoreMSource={SetUNitNumber}
                        SOption={UNitNumber}
                        onChange={(e) => SetUNitNumber(e)}
                        labelname={
                          <div className="DropdownHeader">
                            {" "}
                            Unit Number<span>*</span>{" "}
                          </div>
                        }
                      />
                      {AQErrors?.UNitNumber && (
                        <span className="error-message">
                          {AQErrors?.UNitNumber}
                        </span>
                      )}
                    </Col>
                    <Col>
                      <UnitName SID={items?.subjectId} LoID={items?.subjectId === "4" ? 128 : 125}
                        className={`w-100 ${updateScenario ? "DisabledNCLDropdown" : "NCLDropdown"
                          }`}
                        disable={updateScenario}
                        Displayname="Select Unit Name"
                        PID={UNitNumber}
                        LID={SelectLanguage}
                        StoreMSource={SetUNitName}
                        SOption={UNitName}
                        onChange={(e) => SetUNitName(e)}
                        labelname={
                          <div className="DropdownHeader">
                            {" "}
                            Unit Name<span>*</span>{" "}
                          </div>
                        }
                      />
                      {AQErrors?.UNitName && (
                        <span className="error-message">
                          {AQErrors?.UNitName}
                        </span>
                      )}
                    </Col>
                  </Row>
                )}
              <Row>
                {DisplayDD !== "G" ? (
                  <>
                    {" "}
                    <Col>
                      <ChapterDD LID={items?.subjectId == "4" ? 126 : 123}
                        className={`w-100 ${updateScenario ? "DisabledNCLDropdown" : "NCLDropdown"
                          }`}
                        StoreMSource={SetChapter}
                        SOption={Chapter}
                        onChange={(e) => SetChapter(e)}
                        Displayname="Select Chapter"
                        disable={updateScenario}
                        labelname={
                          <div className="DropdownHeader">
                            CBSE / SCERT Chapter No<span>*</span>
                          </div>
                        }
                      />
                      {AQErrors?.Chapter && (
                        <span className="error-message">
                          {AQErrors?.Chapter}
                        </span>
                      )}
                    </Col>
                    <Col>
                      {items?.subjectId == "4" ? <>
                        <HBookDD
                          className={`w-100 ${updateScenario ? "DisabledNCLDropdown" : "NCLDropdown"
                            }`}
                          Grade={Grade?.value}
                          Chapter={Chapter}
                          GCtype={BType?.value}
                          StoreMSource={SetBook}
                          SOption={Book}
                          onChange={(e) => SetBook(e)}
                          Displayname="Select Book"
                          disable={updateScenario}
                          labelname={
                            <div className="DropdownHeader">
                              Book<span>*</span>
                            </div>
                          }
                        />
                        {AQErrors?.Book && (
                          <span className="error-message">{AQErrors?.Book}</span>
                        )}</>
                        : <>  <TBookDD Displayname="Select Book" className="NCLDropdown w-100" Grade={Grade?.value}
                          Chapter={Chapter} GCtype={BType?.value} StoreMSource={SetBook} SOption={Book}
                          onChange={(e) => SetBook(e)} labelname={<div className="DropdownHeader"> Book<span>*</span> </div>} />
                          {AQErrors?.Book && (<span className="error-message">{AQErrors?.Book}</span>)} </>}

                    </Col>
                  </>
                ) : (
                  <>
                    <Col></Col>
                    <Col></Col>
                  </>
                )}
              </Row>
              {DisplayDD !== "G" && (
                <>
                  {BType?.display !== BTElective ? (
                    items?.subjectId == "4" ?
                      <HBookSubDropDowns
                        className={`w-100 ${updateScenario ? "DisabledNCLDropdown" : "NCLDropdown"
                          }`}
                        Grade={Grade?.value}
                        Chapter={Chapter}
                        Book={Book}
                        GCtype={BType?.value}
                        StoreMSource={SetBSUB}
                        SOption={BSUB?.Value ? BSUB?.Value : BSUB}
                        disable={updateScenario}
                      /> : <TBookSubDropDowns
                        className="NCLDropdown w-100"
                        Grade={Grade?.value}
                        Chapter={Chapter}
                        Book={Book}
                        GCtype={BType?.value}
                        StoreMSource={SetBSUB}
                        SOption={BSUB}
                      // ref={BookRef}
                      />
                  ) : (
                    items?.subjectId == "4" ?
                      <HBookTypeSubDropDowns
                        className={`w-100 ${updateScenario ? "DisabledNCLDropdown" : "NCLDropdown"
                          }`}
                        Grade={Grade?.value}
                        Chapter={Chapter}
                        Book={Book}
                        GCtype={BType?.value}
                        StoreMSource={SetBTSUB}
                        SOption={BTSUB?.Value ? BTSUB?.Value : BTSUB}
                        disable={updateScenario}
                      /> : <TBookTypeSubDropDowns
                        className="NCLDropdown w-100"
                        Grade={Grade?.value}
                        Chapter={Chapter}
                        Book={Book}
                        GCtype={BType?.value}
                        StoreMSource={SetBTSUB}
                        SOption={BTSUB}
                      // ref={BookTypeRef}
                      />
                  )}
                </>
              )}
            </div>
          </div>

          <div className="AddOptions">
            <div className="dflex alignitems AUTitles">
              <div className="dflex alignitems">
                {" "}
                <img src={AP} alt="Learning Outcomes" />{" "}
                <div> Competencies<span className="text-danger">*</span></div>
              </div>{" "}
            </div>
            <div className="container-fluid">
              <Row>
                <Col>
                  <StageDD className="NCLDropdown w-100" StoreMSource={SetSStage} SOption={SStage}
                    onChange={(e) => { SetSStage(e); SetSCGoal(""); SetCompetencie(""); SetFCompetencie(""); }} Displayname="Select Stage" LID={items?.subjectId == "4" ? 86 : 109} SID={items?.subjectId}
                    labelname={<div className="DropdownHeader"> Stage<span>*</span> </div>} />
                  {AQErrors?.SStage && (<span className="error-message"> {AQErrors?.SStage} </span>)}
                </Col>
                <Col>
                  <CircularGoalDD className="NCLDropdown w-100" StoreMSource={SetSCGoal} SOption={SCGoal} PId={SStage}
                    onChange={(e) => { SetSCGoal(e); SetCompetencie(""); }} Displayname="Select Curricular Goal" LID={items?.subjectId == "4" ? 87 : 110} SID={items?.subjectId}
                    labelname={<div className="DropdownHeader"> Curricular Goal<span>*</span> </div>} GetDetails={SetFSCGoal} />
                  {AQErrors?.SCGoal && (<span className="error-message"> {AQErrors?.SCGoal} </span>)}
                  <div className="dflex alignitems CPointer gap-1 mt-1" style={{ fontSize: "10px" }}
                    onClick={() => SetOpenDeatils(FSCGoal)}
                  > <IoInformationCircleOutline /> Click to view Curricular Goal description </div>
                </Col>
                <Col>
                  <CompetenciesDD className="NCLDropdown w-100" StoreMSource={SetCompetencie} SOption={Competencie} PId={SCGoal}
                    onChange={(e) => SetCompetencie(e)} Displayname="Select Competencies" LID={items?.subjectId == "4" ? 88 : 111} SID={items?.subjectId}
                    labelname={<div className="DropdownHeader"> Competencies<span>*</span> </div>} GetDetails={SetFCompetencie} />
                  {AQErrors?.Competencie && (<span className="error-message"> {AQErrors?.Competencie} </span>)}
                  <div className="dflex alignitems CPointer gap-1 mt-1" style={{ fontSize: "10px" }}
                    onClick={() => SetOpenDeatils(FCompetencie)}
                  > <IoInformationCircleOutline /> Click to view Competencies description </div>
                </Col>
              </Row>
            </div>
          </div>
          {DisplayDD !== "G" && (
            <div className="AddOptions">
              <div className="dflex alignitems AUTitles">
                <div className="dflex alignitems">
                  {" "}
                  <img src={AP} alt="Learning Outcomes" />{" "}
                  <div> Process<span className="text-danger">*</span></div>
                </div>{" "}
                {/*<GoTriangleDown onClick={() => OpenAccordain("LOC")} />*/}
              </div>
              <div className="container-fluid">

                <Row>
                  <Col>
                    <PLOneDD
                      className="NCLDropdown w-100" LID={items?.subjectId == "4" ? 82 : 105}
                      StoreMSource={SetLevelOne} SID={items?.subjectId}
                      SOption={LevelOne}
                      onChange={(e) => SetLevelOne(e)}
                      Displayname="Select Level 1"
                      labelname={
                        <div className="DropdownHeader">
                          Level 1<span>*</span>
                        </div>
                      }
                    />
                    {AQErrors?.LevelOne && (
                      <span className="error-message">
                        {AQErrors?.LevelOne}
                      </span>
                    )}
                  </Col>
                  <Col>
                    <PLTwoDD
                      className="NCLDropdown w-100" SID={items?.subjectId}
                      StoreMSource={SetLevelTwo} LID={items?.subjectId == "4" ? 83 : 106}
                      SOption={LevelTwo}
                      PId={LevelOne}
                      onChange={(e) => SetLevelTwo(e)}
                      Displayname="Select Level 2"
                      labelname={
                        <div className="DropdownHeader">
                          Level 2<span>*</span>
                        </div>
                      }
                    />
                    {AQErrors?.LevelTwo && (
                      <span className="error-message">
                        {AQErrors?.LevelTwo}
                      </span>
                    )}
                  </Col>
                  <Col>
                    {" "}
                    <PLThreeDD
                      className="NCLDropdown w-100" SID={items?.subjectId}
                      StoreMSource={SetLevelThree} LID={items?.subjectId == "4" ? 85 : 108}
                      SOption={LevelThree}
                      onChange={(e) => SetLevelThree(e)}
                      Displayname="Select Level 3"
                      labelname={
                        <div className="DropdownHeader">
                          Level 3<span>*</span>
                        </div>
                      }
                    />
                    {AQErrors?.LevelThree && (
                      <span className="error-message">
                        {AQErrors?.LevelThree}
                      </span>
                    )}
                  </Col>
                </Row>
              </div>
            </div>)}
          <div className="AddOptions">
            <div className="dflex alignitems AUTitles">
              <div className="dflex alignitems">
                {" "}
                <img src={AP} alt="Learning Outcomes" />{" "}
                <div>
                  Assessment Parameters<span className="text-danger">*</span>{" "}
                </div>
              </div>{" "}
              {/*<GoTriangleDown onClick={() => OpenAccordain("LOC")} />*/}
            </div>

            <div className="container-fluid">
              {DisplayDD !== "G" && (
                <Row>
                  <Col>
                    <Situation SID={items?.subjectId} LID={items?.subjectId == "4" ? 82 : 105}
                      className={`w-100 ${updateScenario ? "DisabledNCLDropdown" : "NCLDropdown"
                        }`}
                      StoreMSource={SetSLevelOne}
                      SOption={SLevelOne}
                      onChange={(e) => SetSLevelOne(e)}
                      Displayname="Select Situation"
                      labelname={
                        <div className="DropdownHeader">
                          Situation<span>*</span>
                        </div>
                      }
                      disable={updateScenario}
                    />
                    {AQErrors?.SLevelOne && (
                      <span className="error-message">
                        {AQErrors?.SLevelOne}
                      </span>
                    )}
                  </Col>
                  <Col>
                    <TextFormat SID={items?.subjectId} LID={items?.subjectId == "4" ? 82 : 105}
                      className={`w-100 ${updateScenario ? "DisabledNCLDropdown" : "NCLDropdown"
                        }`}
                      StoreMSource={SetTFormat}
                      SOption={TFormat}
                      onChange={(e) => SetTFormat(e)}
                      Displayname="Select Text Format"
                      labelname={
                        <div className="DropdownHeader">
                          Text Format<span>*</span>
                        </div>
                      }
                      disable={updateScenario}
                    />
                    {AQErrors?.TFormat && (
                      <span className="error-message">{AQErrors?.TFormat}</span>
                    )}
                  </Col>
                  <Col>
                    <TType SID={items?.subjectId} LID={items?.subjectId == "4" ? 82 : 105}
                      className={`w-100 ${updateScenario ? "DisabledNCLDropdown" : "NCLDropdown"
                        }`}
                      StoreMSource={SetTexType}
                      SOption={TexType}
                      onChange={(e) => SetTexType(e)}
                      Displayname="Select Text Type"
                      labelname={
                        <div className="DropdownHeader">
                          Text Type<span>*</span>
                        </div>
                      }
                      disable={updateScenario}
                    />
                    {AQErrors?.TexType && (
                      <span className="error-message">{AQErrors?.TexType}</span>
                    )}
                  </Col>
                </Row>
              )}
              <Row>
                <Col>
                  <QuestionLevel
                    className="NCLDropdown w-100"
                    SubjectId={3}
                    // SubjectId={items?.subjectId}
                    StoreValue={SetQLevel}
                    SOption={QLevel}
                    onChange={(e) => SetQLevel(e)}
                    LovCategoryId={43}
                    labelname={
                      <div className="DropdownHeader">
                        Question Level <span>*</span>
                      </div>
                    }
                    LID={SelectLanguage}
                    Displayname="Select Question Level"
                  />
                  {AQErrors?.QLevel && (
                    <span className="error-message">{AQErrors?.QLevel}</span>
                  )}
                </Col>
                <Col>
                  <BloomTaxonomy
                    className="NCLDropdown w-100"
                    SubjectId={3}
                    // SubjectId={items?.subjectId}
                    PId={QLevel}
                    StoreValue={SetBTaxonomy}
                    SOption={BTaxonomy}
                    onChange={(e) => SetBTaxonomy(e)}
                    Displayname="Select Bloom's Taxonomy"
                    LovCategoryId={44}
                    labelname={
                      <div className="DropdownHeader">
                        Bloom's Taxonomy <span>*</span>
                      </div>
                    }
                    LID={SelectLanguage}
                  />
                  {AQErrors?.BTaxonomy && (
                    <span className="error-message">{AQErrors?.BTaxonomy}</span>
                  )}
                </Col>
                {DisplayDD === "G" ? (
                  <Col>
                    <GrammerDD SID={items?.subjectId} LID={items?.subjectId == "4" ? 122 : 121}
                      className="NCLDropdown w-100"
                      StoreMSource={SetGrammer}
                      SOption={Grammer}
                      onChange={(e) => {
                        SetGrammer(e);
                        console.log(e);
                      }}
                      Displayname="Select Grammar"
                      labelname={
                        <div className="DropdownHeader">
                          Grammar <span>*</span>
                        </div>
                      }
                    />
                    {AQErrors?.Grammer && (
                      <span className="error-message">{AQErrors?.Grammer}</span>
                    )}
                  </Col>
                ) : (
                  <Col></Col>
                )}
              </Row>
            </div>
          </div>

          <div className="AddOptions">
            <div className="dflex alignitems JSBetween AUTitles">
              <div className="dflex alignitems">
                {" "}
                <img src={Forms} alt="Assessment Parameters" />{" "}
                <div>
                  Forms In Question <span className="text-danger">*</span>
                </div>
              </div>{" "}
              <GoTriangleDown onClick={() => OpenAccordain("FQ")} />
            </div>
            {Accordion !== "FQ" && (
              <>
                <FormQuestions
                  PostValues={FormQ}
                  onChange={(e) => FormSOptions(e)}
                  LID={SelectLanguage}
                />
                {FormQ.includes(4002) && (
                  <>
                    <input
                      type="text"
                      className="Search mt-2 p-1 w-100"
                      onChange={(e) => HandelOComments("Form", e.target.value)}
                      placeholder="Enter Comments"
                    />
                    {AQErrors?.Form && (
                      <span className="error-message">{AQErrors?.Form}</span>
                    )}
                  </>
                )}
                {AQErrors?.QForm && (
                  <span
                    className="error-message"
                    style={{ marginLeft: "10px" }}
                  >
                    {AQErrors?.QForm}
                  </span>
                )}
              </>
            )}
          </div>
        </div>
        <QBCList
          Heading="Question"
          HValidation={HitCLV}
          RStoreHValidation={SetHitCLV}
          VSuccess={SetCValidation}
          GetValues={SetQCValues}
          Existinvalues={GetQuestion?.status}
          ExistingId={GetQuestion?.checklistQuestionId}
          LanguageId={SelectLanguage}
        />

        <div className="ScenarioAU dflex alignitems">
          <button
            className="Buttons bg-danger"
            onClick={() => BackPreviousPage()}
          >
            Cancel
          </button>
          <button
            className="Buttons bg-success"
            onClick={() => {
              YupValidation();
              SetHitCLV(true);
            }}
          >
            {GetQuestion ? (
              <>
                {" "}
                Update{" "}
                <span style={{ fontSize: "8px" }}>
                  (Please go Through The Below Checklist Before Updating The
                  Question)
                </span>{" "}
              </>
            ) : (
              "Save"
            )}
          </button>
        </div>
      </div>
      {OpenDeatils && (
        <div className="Model-Open">
          <div className="Card w-100 Model-Content">
            <IoMdCloseCircleOutline
              className="NCERTClose CPointer"
              onClick={() => SetOpenDeatils()}
            />
            <DataTable data={OpenDeatils} columns={Columns} className="NCLDataTable"
              Dropdownvalues={["10", "25", "50", "100"]} ShowPagination="true" ShowPagecount="true" />
          </div>
        </div>
      )}
      {Load && <Loading />}
    </>
  );
};
export default AddUpdatHindiQuestions;
